import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b1f2f6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-capitalize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_data_table, {
      class: "my-5 rounded bordered",
      expanded: _ctx.tabel.laiendatud,
      "onUpdate:expanded": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabel.laiendatud) = $event)),
      headers: _ctx.tabel.paised,
      items: _ctx.elemendid,
      "items-per-page": _ctx.tabel.lehePikkus,
      loading: _ctx.tabel.laeb,
      "fixed-header": ""
    }, {
      [`item.kuupaev`]: _withCtx(({ value }) => [
        _createTextVNode(_toDisplayString(_ctx.formateeriKuupaev(value)), 1)
      ]),
      [`item.nadalapaev`]: _withCtx(({ item }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.formateeriNadalaPaev(item.kuupaev as any)), 1)
      ]),
      [`item.algus`]: _withCtx(({ value }) => [
        _createTextVNode(_toDisplayString(_ctx.formateeriAeg(value)), 1)
      ]),
      [`item.lopp`]: _withCtx(({ value }) => [
        _createTextVNode(_toDisplayString(_ctx.formateeriAeg(value)), 1)
      ]),
      [`item.aeg`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.formateeriAeg(item.algus as any)) + " - " + _toDisplayString(_ctx.formateeriAeg(item.lopp as any)), 1)
      ]),
      [`item.louna`]: _withCtx(({ value }) => [
        _createTextVNode(_toDisplayString(value) + "min ", 1)
      ]),
      bottom: _withCtx(() => []),
      _: 2
    }, 1032, ["expanded", "headers", "items", "items-per-page", "loading"])
  ]))
}